import IconComponent from "icons/IconComponent";

import DiscountIcon from "./discount.svg";

export default (DiscountIcon as any) as IconComponent;
